import { render } from "./AdminCareId.vue?vue&type=template&id=1caf19a9&scoped=true"
import script from "./AdminCareId.vue?vue&type=script&lang=js"
export * from "./AdminCareId.vue?vue&type=script&lang=js"

import "./AdminCareId.vue?vue&type=style&index=0&id=1caf19a9&lang=css"
import "./AdminCareId.vue?vue&type=style&index=1&id=1caf19a9&lang=css&scoped=true"
import "./AdminCareId.vue?vue&type=style&index=2&id=1caf19a9&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caf19a9"]])

export default __exports__